import { cn } from '@/lib/cn';
import { AlertCircle, CheckCircle2, Info } from 'lucide-react';

type Variant = 'info' | 'success' | 'error' | 'warning';

const styles: Record<Variant, { box: string; icon: typeof Info }> = {
  info: { box: 'bg-sky-50 border-sky-200 text-sky-900', icon: Info },
  success: { box: 'bg-emerald-50 border-emerald-200 text-emerald-900', icon: CheckCircle2 },
  error: { box: 'bg-red-50 border-red-200 text-red-900', icon: AlertCircle },
  warning: { box: 'bg-amber-50 border-amber-200 text-amber-900', icon: AlertCircle },
};

export function Alert({
  variant = 'info',
  title,
  children,
  className,
}: {
  variant?: Variant;
  title?: string;
  children: React.ReactNode;
  className?: string;
}) {
  const Icon = styles[variant].icon;

  return (
    <div
      className={cn(
        'flex gap-3 rounded-xl border px-4 py-3 text-sm',
        styles[variant].box,
        className,
      )}
    >
      <Icon className="h-5 w-5 shrink-0 mt-0.5" />
      <div>
        {title && <p className="font-medium mb-0.5">{title}</p>}
        <div className="opacity-90">{children}</div>
      </div>
    </div>
  );
}
